import template from './contactNameCell.html';
import controller from './contactNameCellCtrl';
import './style.scss';

export default {
  template,
  controller,
  bindings: {
    contactName: '<',
    loanId: '<',
    opportunityId: '<',
    onGoTo: '&',
    cardDetails: '<',
    isApplication: '<',
    onRowClick: '&',
  },
};
